import Cookies from 'js-cookie';
import { COOKIE_EXPIRE_MINUTES, NODE_ENV } from '../config/system/systemConfig';

export function getAllCookies() {
  try {
    return Cookies.get();
  }
  catch (error) {
    throw error;
  }
}

export function setCookie(
  key: string,
  value: string
) {
  try {
    const expire_time : number = setCookieWithExpiryInDays(COOKIE_EXPIRE_MINUTES);

    const cookie = Cookies.set(key, value, {
      // domain: process.env.REACT_APP_DOMAIN,
      expires: expire_time,
      secure: window.location.protocol === 'https:',
      sameSite: 'Lax',
      path: '/'
    });

    return cookie;
  }
  catch (error) {
    throw error;
  }
}

const setCookieWithExpiryInDays = (minutes: number): number => {
  return minutes / (24 * 60);
};

export function getCookie(key: string) {
  try {
    return Cookies.get(key);
  }
  catch (error) {
    throw error;
  }
}

export function removeCookie(key: string) {
  try {
    return Cookies.remove(key, {
      domain: process.env.REACT_APP_DOMAIN,
    });
  }
  catch (error) {
    throw error;
  }
}
